// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "event_trade.proto" (syntax proto3)
// tslint:disable
import { EventTradeService } from "./event_trade";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service EventTradeService
 */
export class EventTradeServiceClient {
    constructor(_transport) {
        this._transport = _transport;
        this.typeName = EventTradeService.typeName;
        this.methods = EventTradeService.methods;
        this.options = EventTradeService.options;
    }
    /**
     * @generated from protobuf rpc: CreateEventTrade
     */
    createEventTrade(input, options) {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetEventTrade
     */
    getEventTrade(input, options) {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetEventTrade
     */
    batchGetEventTrade(input, options) {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateEventTrade
     */
    updateEventTrade(input, options) {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteEventTrade
     */
    deleteEventTrade(input, options) {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: CreateEventTradeRule
     */
    createEventTradeRule(input, options) {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetEventTradeRule
     */
    getEventTradeRule(input, options) {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: BatchGetEventTradeRule
     */
    batchGetEventTradeRule(input, options) {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: UpdateEventTradeRule
     */
    updateEventTradeRule(input, options) {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: DeleteEventTradeRule
     */
    deleteEventTradeRule(input, options) {
        const method = this.methods[9], opt = this._transport.mergeOptions(options);
        return stackIntercept("unary", this._transport, method, opt, input);
    }
}
